import GoogleIcon from "../../Assets/Icons/google-icon.svg";
import "./GoogleAuthButton.scss";

const generateGoogleRedirectUrl = () => {
  const baseAuthUrl = new URL("https://accounts.google.com/o/oauth2/v2/auth");

  const searchParams = {
    client_id:
      "815262930872-9h0khuo82dqui5gfn7i9ifu9t1oq4hq9.apps.googleusercontent.com",
    scope: "profile email",
    redirect_uri: `${window.location.origin}/google-auth`,
    response_type: "id_token",
    prompt: "select_account",
    nonce: "randompleasechangeme",
  };

  Object.entries(searchParams).forEach(([paramKey, paramValue]) => {
    baseAuthUrl.searchParams.append(paramKey, paramValue);
  });

  return baseAuthUrl.href;
};

export default function GoogleAuthButton({ text = "Continue with Google" }) {
  const handleClick = () => {
    window.location.href = generateGoogleRedirectUrl();
  };

  return (
    <button onClick={handleClick} className="google-auth-button">
      <img
        src={GoogleIcon}
        alt="google-icon"
        className="google-auth-button__icon"
      />
      <span className="google-auth-button__text">{text}</span>
    </button>
  );
}
